import CountryPageRenderer from '../components/CountryPageRenderer';
import romaniaData from '../data/country-pages/romania';

export default function RomaniaCountryPage() {
  return <CountryPageRenderer data={romaniaData} />;
}
